import { RegionMetaData } from '../../constants/region.constants';
import {
  Region,
  RegionMeta,
  RegionResponse,
  TokenRegion,
} from '../../models/region.model';

export function mapRegionResponseToModel(response: RegionResponse): Region {
  // Special handling for product page restrictions
  const showProductPage =
    response.show_products_page && !response.show_custom_products_page;

  // Special handling for downloads page restrictions
  const showDownloadsPage = response.region_code === 'US';

  // Get region metadata
  const regionMetadata: RegionMeta | undefined =
    RegionMetaData[response.region_code];

  return {
    id: response.region_id,
    code: response.region_code,
    label: response.region_name,
    colorCode: regionMetadata?.colorCode || '#00000066',
    pageRestrictions: {
      product: showProductPage,
      productImport: response.show_custom_products_page,
      pricing: response.show_pricing_page,
      inventory: response.show_inventory_page,
      buyerAddressImport: response.show_buyer_address_page,
      buyerImport: response.show_buyer_page,
      downloads: showDownloadsPage,
    },
  };
}

export function mapTokenRegionsToModel(
  regions: Region[],
  tokenRegions: TokenRegion[],
): Region[] {
  const assignedIds = new Set(tokenRegions.map((item) => item.id));
  return regions
    .filter((r) => assignedIds.has(r.id))
    .sort((a, b) => a.id - b.id);
}
